import { Box, useTheme } from "@mui/material";
import { useMemo } from "react";

const HandsomeHomebuyerLogo = ({
  width = "225px",
  height = "auto",
  sx = {},
}) => {
  const theme = useTheme();

  const styles = useMemo(
    () => ({
      cursor: "pointer",
      display: "inline-block",
      width,
      height,
      padding: 0,
      border: "none",
      background: "none",
      "&:focus": {
        outline: `2px solid ${theme.palette.primary.dark}`,
        outlineOffset: 2,
      },
      ...sx,
    }),
    [sx, width, height, theme.palette.primary.dark]
  );

  return (
    <Box sx={styles}>
      <svg
        role="img"
        aria-labelledby="handsomeLogoTitle"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 786.18665 186.53333"
      >
        <title id="handsomeLogoTitle">Handsome Homebuyer Logo</title>
        {/* your existing <g>…</g> paths here, but replace hardcoded fill with {fillColor} */}
        <g id="g8" transform="matrix(1.3333333,0,0,-1.3333333,0,186.53333)">
          <g id="g10" transform="scale(0.1)">
            <path
              d="M 384.031,860.512 C 256.02,786.605 128.012,712.699 0,638.793 V 512.094 l 109.723,63.351 V 0 H 1316.68 v 575.445 l 109.72,-63.351 v 126.699 c -128,73.906 -256.02,147.812 -384.03,221.719 V 987.211 C 950.938,1040 859.504,1092.79 768.066,1145.58 v 253.4 c -128.011,-73.91 -256.023,-147.82 -384.035,-221.72 0,-105.58 0,-211.166 0,-316.748 z m 548.621,63.347 V 438.895 h 109.718 v 294.918 l 164.59,-95.02 V 0 H 1042.37 V 274.309 H 932.652 V 0 H 768.066 c 0,339.629 0,679.258 0,1018.89 l 164.586,-95.031 z m -438.898,190.051 164.586,95.02 c 0,-402.973 0,-805.95 0,-1208.93 H 493.754 V 274.309 H 384.031 V 0 H 219.445 v 638.793 l 164.586,95.023 V 438.895 h 109.723 c 0,225.003 0,450.011 0,675.015 v 0"
              fill="#fbca0b"
            />
            <path
              d="M 1985.66,932.73 V 528.887 H 1892.2 V 694.461 H 1708.74 V 528.887 h -93.46 V 932.73 h 93.46 V 773.5 h 183.46 v 159.23 h 93.46"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path14"
            />
            <path
              d="m 2364.1,686.387 -64.04,154.609 -64.04,-154.609 z m 29.42,-70.965 h -187.5 l -35.76,-86.535 h -95.77 l 179.99,403.843 h 92.31 l 180.58,-403.843 h -98.08 l -35.77,86.535"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path16"
            />
            <path
              d="M 2986,932.73 V 528.887 h -76.73 L 2707.92,774.074 V 528.887 h -92.3 V 932.73 h 77.3 L 2893.69,687.539 V 932.73 H 2986"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path18"
            />
            <path
              d="m 3306.75,605.613 c 80.19,0 132.69,47.887 132.69,125.192 0,77.308 -52.5,125.195 -132.69,125.195 h -85.39 V 605.613 Z M 3127.9,932.73 h 183.46 c 132.12,0 222.69,-79.617 222.69,-201.925 0,-122.305 -90.57,-201.918 -222.69,-201.918 H 3127.9 V 932.73"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path20"
            />
            <path
              d="m 3618.84,568.691 31.73,70.387 c 34.04,-24.808 84.81,-42.113 133.27,-42.113 55.38,0 77.88,18.457 77.88,43.265 0,75.579 -234.81,23.657 -234.81,173.653 0,68.656 55.39,125.769 170.2,125.769 50.76,0 102.69,-12.117 140.19,-35.769 l -28.85,-70.961 c -37.5,21.344 -76.15,31.73 -111.92,31.73 -55.39,0 -76.73,-20.765 -76.73,-46.152 0,-74.426 234.8,-23.078 234.8,-171.344 0,-67.504 -55.96,-125.195 -171.34,-125.195 -64.04,0 -128.65,19.039 -164.42,46.73"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path22"
            />
            <path
              d="m 4386.7,730.805 c 0,76.734 -54.23,129.23 -126.35,129.23 -72.11,0 -126.34,-52.496 -126.34,-129.23 0,-76.727 54.23,-129.227 126.34,-129.227 72.12,0 126.35,52.5 126.35,129.227 z m -347.31,0 c 0,120 93.46,208.847 220.96,208.847 126.92,0 220.96,-88.269 220.96,-208.847 0,-120.575 -94.04,-208.844 -220.96,-208.844 -127.5,0 -220.96,88.848 -220.96,208.844"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path24"
            />
            <path
              d="m 4965.33,528.887 -0.58,242.304 -118.85,-199.617 h -42.11 L 4685.52,766 V 528.887 h -87.69 V 932.73 h 77.31 l 151.15,-250.96 148.85,250.96 h 76.72 l 1.16,-403.843 h -87.69"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path26"
            />
            <path
              d="m 5507.6,603.887 v -75 H 5194.91 V 932.73 h 305.19 v -75 h -212.31 v -87.691 h 187.51 v -72.691 h -187.51 v -93.461 h 219.81"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path28"
            />
            <path
              d="M 1985.66,410.773 V 6.92969 H 1892.2 V 172.5 H 1708.74 V 6.92969 h -93.46 V 410.773 h 93.46 V 251.539 h 183.46 v 159.234 h 93.46"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path30"
            />
            <path
              d="m 2449.48,208.852 c 0,76.73 -54.23,129.23 -126.34,129.23 -72.12,0 -126.35,-52.5 -126.35,-129.23 0,-76.731 54.23,-129.2309 126.35,-129.2309 72.11,0 126.34,52.4999 126.34,129.2309 z m -347.3,0 c 0,120 93.46,208.839 220.96,208.839 126.92,0 220.96,-88.269 220.96,-208.839 C 2544.1,88.2695 2450.06,0 2323.14,0 2195.64,0 2102.18,88.8516 2102.18,208.852"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path32"
            />
            <path
              d="M 3028.11,6.92969 3027.54,249.23 2908.69,49.6211 h -42.11 L 2748.31,244.039 V 6.92969 h -87.69 V 410.773 h 77.3 l 151.15,-250.964 148.85,250.964 h 76.73 L 3115.8,6.92969 h -87.69"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path34"
            />
            <path
              d="M 3570.39,81.9297 V 6.92969 H 3257.7 V 410.773 h 305.19 V 335.77 h -212.31 v -87.688 h 187.5 v -72.691 h -187.5 V 81.9297 h 219.81"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path36"
            />
            <path
              d="m 3967.29,126.93 c 0,34.039 -25.96,50.191 -74.42,50.191 H 3783.83 V 77.3086 h 109.04 c 48.46,0 74.42,15 74.42,49.6214 z m -183.46,213.461 v -95.2 h 92.88 c 45.58,0 70.39,16.161 70.39,47.891 0,31.727 -24.81,47.309 -70.39,47.309 z m 277.5,-223.27 C 4061.33,47.3086 4005.94,6.92969 3899.79,6.92969 H 3690.95 V 410.773 h 197.3 c 100.96,0 152.88,-42.113 152.88,-105.003 0,-40.379 -20.76,-71.54 -53.65,-88.84 45,-14.43 73.85,-49.039 73.85,-99.809"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path38"
            />
            <path
              d="m 4174.97,184.621 v 226.152 h 93.46 V 188.082 c 0,-76.73 33.46,-108.4609 90,-108.4609 57.11,0 90,31.7309 90,108.4609 v 222.691 h 92.3 V 184.621 C 4540.73,65.7695 4472.66,0 4357.85,0 4243.04,0 4174.97,65.7695 4174.97,184.621"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path40"
            />
            <path
              d="M 4867.25,150 V 6.92969 h -93.46 V 151.16 l -156.34,259.613 h 99.23 l 107.88,-179.421 107.88,179.421 h 91.73 L 4867.25,150"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path42"
            />
            <path
              d="M 5418.2,81.9297 V 6.92969 H 5105.51 V 410.773 H 5410.7 V 335.77 H 5198.39 V 248.082 H 5385.9 V 175.391 H 5198.39 V 81.9297 h 219.81"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path44"
            />
            <path
              d="m 5708.37,334.621 h -76.15 V 193.852 h 76.15 c 57.12,0 85.97,26.539 85.97,70.378 0,44.43 -28.85,70.391 -85.97,70.391 z M 5796.07,6.92969 5718.18,119.43 h -85.96 V 6.92969 h -93.46 V 410.773 h 174.8 c 107.89,0 175.39,-55.964 175.39,-146.543 0,-60.57 -30.58,-105 -83.08,-127.492 L 5896.45,6.92969 h -100.38"
              style={{
                fill: "#1e3450",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
              }}
              id="path46"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
};

//   <g
//       id="g8"
//       inkscape:groupmode="layer"
//       inkscape:label="ink_ext_XXXXXX"
//       transform="matrix(1.3333333,0,0,-1.3333333,0,186.53333)"
//     >
//       <g id="g10" transform="scale(0.1)">
//         <path
//           d="M 384.031,860.512 C 256.02,786.605 128.012,712.699 0,638.793 V 512.094 l 109.723,63.351 V 0 H 1316.68 v 575.445 l 109.72,-63.351 v 126.699 c -128,73.906 -256.02,147.812 -384.03,221.719 V 987.211 C 950.938,1040 859.504,1092.79 768.066,1145.58 v 253.4 c -128.011,-73.91 -256.023,-147.82 -384.035,-221.72 0,-105.58 0,-211.166 0,-316.748 z m 548.621,63.347 V 438.895 h 109.718 v 294.918 l 164.59,-95.02 V 0 H 1042.37 V 274.309 H 932.652 V 0 H 768.066 c 0,339.629 0,679.258 0,1018.89 l 164.586,-95.031 z m -438.898,190.051 164.586,95.02 c 0,-402.973 0,-805.95 0,-1208.93 H 493.754 V 274.309 H 384.031 V 0 H 219.445 v 638.793 l 164.586,95.023 V 438.895 h 109.723 c 0,225.003 0,450.011 0,675.015 v 0"
//           style="fill:#fbca0b;fill-opacity:1;fill-rule:evenodd;stroke:none"
//           id="path12"
//         />
//         <path
//           d="M 1985.66,932.73 V 528.887 H 1892.2 V 694.461 H 1708.74 V 528.887 h -93.46 V 932.73 h 93.46 V 773.5 h 183.46 v 159.23 h 93.46"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path14"
//         />
//         <path
//           d="m 2364.1,686.387 -64.04,154.609 -64.04,-154.609 z m 29.42,-70.965 h -187.5 l -35.76,-86.535 h -95.77 l 179.99,403.843 h 92.31 l 180.58,-403.843 h -98.08 l -35.77,86.535"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path16"
//         />
//         <path
//           d="M 2986,932.73 V 528.887 h -76.73 L 2707.92,774.074 V 528.887 h -92.3 V 932.73 h 77.3 L 2893.69,687.539 V 932.73 H 2986"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path18"
//         />
//         <path
//           d="m 3306.75,605.613 c 80.19,0 132.69,47.887 132.69,125.192 0,77.308 -52.5,125.195 -132.69,125.195 h -85.39 V 605.613 Z M 3127.9,932.73 h 183.46 c 132.12,0 222.69,-79.617 222.69,-201.925 0,-122.305 -90.57,-201.918 -222.69,-201.918 H 3127.9 V 932.73"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path20"
//         />
//         <path
//           d="m 3618.84,568.691 31.73,70.387 c 34.04,-24.808 84.81,-42.113 133.27,-42.113 55.38,0 77.88,18.457 77.88,43.265 0,75.579 -234.81,23.657 -234.81,173.653 0,68.656 55.39,125.769 170.2,125.769 50.76,0 102.69,-12.117 140.19,-35.769 l -28.85,-70.961 c -37.5,21.344 -76.15,31.73 -111.92,31.73 -55.39,0 -76.73,-20.765 -76.73,-46.152 0,-74.426 234.8,-23.078 234.8,-171.344 0,-67.504 -55.96,-125.195 -171.34,-125.195 -64.04,0 -128.65,19.039 -164.42,46.73"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path22"
//         />
//         <path
//           d="m 4386.7,730.805 c 0,76.734 -54.23,129.23 -126.35,129.23 -72.11,0 -126.34,-52.496 -126.34,-129.23 0,-76.727 54.23,-129.227 126.34,-129.227 72.12,0 126.35,52.5 126.35,129.227 z m -347.31,0 c 0,120 93.46,208.847 220.96,208.847 126.92,0 220.96,-88.269 220.96,-208.847 0,-120.575 -94.04,-208.844 -220.96,-208.844 -127.5,0 -220.96,88.848 -220.96,208.844"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path24"
//         />
//         <path
//           d="m 4965.33,528.887 -0.58,242.304 -118.85,-199.617 h -42.11 L 4685.52,766 V 528.887 h -87.69 V 932.73 h 77.31 l 151.15,-250.96 148.85,250.96 h 76.72 l 1.16,-403.843 h -87.69"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path26"
//         />
//         <path
//           d="m 5507.6,603.887 v -75 H 5194.91 V 932.73 h 305.19 v -75 h -212.31 v -87.691 h 187.51 v -72.691 h -187.51 v -93.461 h 219.81"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path28"
//         />
//         <path
//           d="M 1985.66,410.773 V 6.92969 H 1892.2 V 172.5 H 1708.74 V 6.92969 h -93.46 V 410.773 h 93.46 V 251.539 h 183.46 v 159.234 h 93.46"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path30"
//         />
//         <path
//           d="m 2449.48,208.852 c 0,76.73 -54.23,129.23 -126.34,129.23 -72.12,0 -126.35,-52.5 -126.35,-129.23 0,-76.731 54.23,-129.2309 126.35,-129.2309 72.11,0 126.34,52.4999 126.34,129.2309 z m -347.3,0 c 0,120 93.46,208.839 220.96,208.839 126.92,0 220.96,-88.269 220.96,-208.839 C 2544.1,88.2695 2450.06,0 2323.14,0 2195.64,0 2102.18,88.8516 2102.18,208.852"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path32"
//         />
//         <path
//           d="M 3028.11,6.92969 3027.54,249.23 2908.69,49.6211 h -42.11 L 2748.31,244.039 V 6.92969 h -87.69 V 410.773 h 77.3 l 151.15,-250.964 148.85,250.964 h 76.73 L 3115.8,6.92969 h -87.69"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path34"
//         />
//         <path
//           d="M 3570.39,81.9297 V 6.92969 H 3257.7 V 410.773 h 305.19 V 335.77 h -212.31 v -87.688 h 187.5 v -72.691 h -187.5 V 81.9297 h 219.81"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path36"
//         />
//         <path
//           d="m 3967.29,126.93 c 0,34.039 -25.96,50.191 -74.42,50.191 H 3783.83 V 77.3086 h 109.04 c 48.46,0 74.42,15 74.42,49.6214 z m -183.46,213.461 v -95.2 h 92.88 c 45.58,0 70.39,16.161 70.39,47.891 0,31.727 -24.81,47.309 -70.39,47.309 z m 277.5,-223.27 C 4061.33,47.3086 4005.94,6.92969 3899.79,6.92969 H 3690.95 V 410.773 h 197.3 c 100.96,0 152.88,-42.113 152.88,-105.003 0,-40.379 -20.76,-71.54 -53.65,-88.84 45,-14.43 73.85,-49.039 73.85,-99.809"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path38"
//         />
//         <path
//           d="m 4174.97,184.621 v 226.152 h 93.46 V 188.082 c 0,-76.73 33.46,-108.4609 90,-108.4609 57.11,0 90,31.7309 90,108.4609 v 222.691 h 92.3 V 184.621 C 4540.73,65.7695 4472.66,0 4357.85,0 4243.04,0 4174.97,65.7695 4174.97,184.621"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path40"
//         />
//         <path
//           d="M 4867.25,150 V 6.92969 h -93.46 V 151.16 l -156.34,259.613 h 99.23 l 107.88,-179.421 107.88,179.421 h 91.73 L 4867.25,150"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path42"
//         />
//         <path
//           d="M 5418.2,81.9297 V 6.92969 H 5105.51 V 410.773 H 5410.7 V 335.77 H 5198.39 V 248.082 H 5385.9 V 175.391 H 5198.39 V 81.9297 h 219.81"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path44"
//         />
//         <path
//           d="m 5708.37,334.621 h -76.15 V 193.852 h 76.15 c 57.12,0 85.97,26.539 85.97,70.378 0,44.43 -28.85,70.391 -85.97,70.391 z M 5796.07,6.92969 5718.18,119.43 h -85.96 V 6.92969 h -93.46 V 410.773 h 174.8 c 107.89,0 175.39,-55.964 175.39,-146.543 0,-60.57 -30.58,-105 -83.08,-127.492 L 5896.45,6.92969 h -100.38"
//           style="fill:#1e3450;fill-opacity:1;fill-rule:nonzero;stroke:none"
//           id="path46"
//         />
//   </g>
// </g>

export default HandsomeHomebuyerLogo;
